module.exports = __webpack_public_path__ + "static/media/login-splash.4f17866d.jpg";